module.exports = __webpack_public_path__ + "static/loja_4-ed51dafe99e30fbfba48155619288ae9.png";